var React = require('react');

function PrinterIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"primary-fill","d":"M7.7,0h5.09a1,1,0,0,1,1,1V3.14H6.7V1A1,1,0,0,1,7.7,0Z","key":0}),React.createElement("path",{"className":"primary-fill","d":"M10.24,2.14a15,15,0,0,1,6.9,1.58c0,.1-13.73,0-13.79,0A15.56,15.56,0,0,1,10.24,2.14Z","key":1}),React.createElement("path",{"className":"primary-fill","d":"M6.07,9.16h8l2,7.32H4Z","key":2}),React.createElement("path",{"className":"primary-fill","d":"M16.9,4.94H3.59a3.59,3.59,0,1,0,0,7.17h.58L5.25,8.27h9.61l1.08,3.84h1a3.59,3.59,0,1,0,0-7.17Z","key":3})]);
}

PrinterIcon.defaultProps = {"viewBox":"0 0 20.49 16.48","className":"printer icon"};

module.exports = PrinterIcon;

PrinterIcon.default = PrinterIcon;
